var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require(`@/assets/images/${_vm.imgName}`),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }